import { pathname, getGeoLocationData, URL_PARAMS_ON_SIGNUP } from '.';
import { parse } from 'qs';

export function isLinesPage() {
  return window.location.pathname === pathname.lines.url;
}

export function forwardUrlParams() {
  const params = new URLSearchParams(window.location.search)?.toString();
  return params && `?${params}`;
}

export async function getUrlSignUpParams() {
  let params = localStorage.getItem(URL_PARAMS_ON_SIGNUP);
  if (!params) {
    params = new URLSearchParams(window.location.search)?.toString();
  }
  const parsedParams = parse(params);
  const geoLocationData = await getGeoLocationData();
  parsedParams['geolocation_data'] = geoLocationData;
  return parsedParams;
}

const messages = {
  CBB: {
    homeWebUrl: 'https://www.8fig.co',
    faqUrl: 'https://www.8fig.co/faq/',
    termsOfUseUrl: 'https://www.8fig.co/terms-of-use',
    privacyPolicyUrl: `https://www.8fig.co/privacy-policy`,
  },
  '8DATA': {
    homeWebUrl: `https://8data.co`,
    faqUrl: 'https://8data.co',
    termsOfUseUrl: 'https://8data.co/terms-and-conditions/',
    privacyPolicyUrl: 'https://8data.co/privacy-policy/',
  },
};

const THEME = process.env.REACT_APP_THEME;

export const homeWebUrl = messages[THEME].homeWebUrl;
export const faqUrl = messages[THEME].faqUrl;
export const termsOfUseUrl = messages[THEME].termsOfUseUrl;
export const privacyPolicyUrl = messages[THEME].privacyPolicyUrl;
